import React from 'react'
import tw, { css } from 'twin.macro'
import { Global } from '@emotion/react'
export const GlobalStyles = () => (
	<Global
		styles={css`
				/*! Custom Globals */
				&:focus {
					outline: #58c8df 5px auto;
				}
				[data-reach-menu] {
					${tw`absolute`}
				}
				[data-reach-menu-item] {
					${tw`cursor-pointer block px-1 py-1`}
				}
				[data-reach-menu],
				[data-reach-dialog-overlay],
				[data-reach-combobox-popover] {
					z-index: 100;
				}
				[data-reach-menu-items], [data-reach-menu-list] {
					display: block;
					white-space: nowrap;
					border: 1px solid rgba(0,0,0,.25);
					background: rgba(255,255,255,.99);
					outline: none;
					padding: 1rem 0;
					font-size: 85%;
				}
				[data-reach-tab-panel] {
					min-height: 500px;
				}
				@keyframes slide-down {
					0% {
						opacity: 0;
						transform: translateY(-25px) translateX(-50%);
					}
					100% {
						opacity: 1;
						transform: translateY(15px) translateX(-50%);
					}
				}
				.form-list[data-reach-menu-list] {
					${tw`pt-4 pb-2`}
					${tw`text-black text-base bg-gray-200 border-black border-2 border-t-0 rounded-b rounded-t-none -mt-1`}
					${tw`focus:outline-none`}
					box-shadow: rgba(50, 50, 50, 0.1) 0px 10px 10px,
						rgba(50, 50, 50, 0.12) 0px 15px 10px,
						rgba(50, 50, 50, 0.1) 0px 5px 15px;
					&.valid {
						${tw`border-green-500`}
						&:focus {
							box-shadow: 0 0 0 3px rgba(39, 174, 96, 0.5);
						}
					}
					&.invalid {
						${tw`border-red-500`}
						&:focus {
							box-shadow: 0 0 0 3px rgba(246, 85, 34, 0.5);
						}
					}
					[data-reach-menu-item] {
						${tw`py-2 px-4 font-sans font-normal text-sm`}
					}
					[data-reach-menu-item][data-selected] {
						${tw`bg-gray-200 text-black hover:text-gray-200 hover:bg-black`}
					}
				}
				.slide-down[data-reach-menu-list],
				.slide-down[data-reach-menu-items],
				.slide-down[data-reach-combobox-list] {
					animation: slide-down 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955);
				}
				.contrast-dropdown[data-reach-menu-list], .contrast-dropdown[data-reach-menu-items], .contrast-dropdown[data-reach-combobox-list]{
					${tw`px-2 pt-4 pb-2`}
					${tw`text-black text-base bg-gray-200 border-black border-2 border-t-0 rounded-b rounded-t-none -mt-1`}
					box-shadow: rgba(50, 50, 50, 0.1) 0px 10px 10px,
						rgba(50, 50, 50, 0.12) 0px 15px 10px,
						rgba(50, 50, 50, 0.1) 0px 5px 15px;
					&.valid {
						${tw`border-green-500`}
						&:focus {
							box-shadow: 0 0 0 3px rgba(39, 174, 96, 0.5);
						}
					}
					&.invalid {
						${tw`border-red-500`}
						&:focus {
							box-shadow: 0 0 0 3px rgba(246, 85, 34, 0.5);
						}
					}
					&:focus {
						box-shadow: 0 0 0 3px rgba(226, 232, 240, 0.5);
						${tw`rounded-b-none rounded-t-md`}
					}
					[data-reach-combobox-option],[data-reach-menu-item] {
						${tw`py-2 px-2 font-sans font-normal text-sm hover:bg-gray-400 rounded cursor-pointer`}
						&[data-selected] {
							${tw`bg-gray-400`}
						}
					}
				}

				html {
					${tw`font-sans font-normal subpixel-antialiased text-base bg-white text-dolphin-gray`}
					-webkit-text-size-adjust: 100%;
					box-sizing: border-box;
					line-height: 1.15;
				}
				.container {
					/* Base 100% */
					/* width: 100%; */
					/* Small (sm) */
					@media (min-width: 640px) {
						max-width: 640px;
					}

					/* Medium (md) */
					@media (min-width: 768px) {
						max-width: 768px;
					}

					/* Large (lg) */
					@media (min-width: 1024px) {
						max-width: 1024px;
					}

					/* Extra Large (xl) */
					@media (min-width: 1280px) {
						max-width: 1280px;
					}
				}
				/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
				body {
					margin: 0;
				}
				main {
					display: block;
				}
				h1 {
					font-size: 2rem;
					margin: 0.67rem 0;
				}
				hr {
					box-sizing: content-box;
					height: 0;
					overflow: visible;
				}
				pre {
					font-family: monospace, monospace;
					font-size: 1rem;
				}
				a {
					background-color: transparent;
				}
				abbr[title] {
					border-bottom: none;
					text-decoration: underline;
					-webkit-text-decoration: underline dotted;
					text-decoration: underline dotted;
				}
				b,
				strong {
					font-weight: bolder;
				}
				code,
				kbd,
				samp {
					font-family: monospace, monospace;
					font-size: 1rem;
				}
				small {
					font-size: 80%;
				}
				sub,
				sup {
					font-size: 75%;
					line-height: 0;
					position: relative;
					vertical-align: baseline;
				}
				sub {
					bottom: -0.25rem;
				}
				sup {
					top: -0.5rem;
				}
				img {
					border-style: none;
				}
				button,
				input,
				optgroup,
				select,
				textarea {
					font-family: inherit;
					font-size: 100%;
					line-height: 1.15;
					margin: 0;
				}
				button,
				input {
					overflow: visible;
				}
				button,
				select {
					text-transform: none;
				}
				[type='button'],
				[type='reset'],
				[type='submit'],
				button {
					-webkit-appearance: button;
				}
				[type='button']::-moz-focus-inner,
				[type='reset']::-moz-focus-inner,
				[type='submit']::-moz-focus-inner,
				button::-moz-focus-inner {
					border-style: none;
					padding: 0;
				}
				[type='button']:-moz-focusring,
				[type='reset']:-moz-focusring,
				[type='submit']:-moz-focusring,
				button:-moz-focusring {
					outline: 1px dotted ButtonText;
				}
				fieldset {
					padding: 0.35rem 0.75rem 0.625rem;
				}
				legend {
					box-sizing: border-box;
					color: inherit;
					display: table;
					max-width: 100%;
					padding: 0;
					white-space: normal;
				}
				progress {
					vertical-align: baseline;
				}
				textarea {
					overflow: auto;
				}
				[type='checkbox'],
				[type='radio'] {
					box-sizing: border-box;
					padding: 0;
				}
				[type='number']::-webkit-inner-spin-button,
				[type='number']::-webkit-outer-spin-button {
					height: auto;
				}
				[type='search'] {
					-webkit-appearance: textfield;
					outline-offset: -2px;
				}
				[type='search']::-webkit-search-decoration {
					-webkit-appearance: none;
				}
				::-webkit-file-upload-button {
					-webkit-appearance: button;
					font: inherit;
				}
				details {
					display: block;
				}
				summary {
					display: list-item;
				}
				template {
					display: none;
				}
				[hidden] {
					display: none !important;
				}
				*,
				::after,
				::before {
					box-sizing: inherit;
				}
				blockquote,
				dd,
				dl,
				figure,
				h1,
				h2,
				h3,
				h4,
				h5,
				h6,
				p,
				pre {
					margin: 0;
				}
				button {
					background: 0 0;
					padding: 0;
				}
				button:focus {
					${tw`focus:shadow-outline outline-none`}
				}
				fieldset {
					margin: 0;
					padding: 0;
				}
				ol,
				ul {
					list-style: none;
					margin: 0;
					padding: 0;
				}
				*,
				::after,
				::before {
					border-width: 0;
					border-style: solid;
					border-color: #e2e8f0;
				}
				img {
					border-style: solid;
				}
				textarea {
					resize: vertical;
				}
				input:-ms-input-placeholder,
				textarea:-ms-input-placeholder {
					color: inherit;
					opacity: 0.5;
				}
				input::-ms-input-placeholder,
				textarea::-ms-input-placeholder {
					color: inherit;
					opacity: 0.5;
				}
				input::placeholder,
				textarea::placeholder {
					color: inherit;
					opacity: 0.5;
				}
				[role='button'],
				button {
					cursor: pointer;
				}
				table {
					border-collapse: collapse;
				}
				h1,
				h2,
				h3,
				h4,
				h5,
				h6 {
					font-size: inherit;
					font-weight: inherit;
				}
				a {
					color: inherit;
					text-decoration: inherit;
				}
				button,
				input,
				optgroup,
				select,
				textarea {
					padding: 0;
					line-height: inherit;
					color: inherit;
				}
				code,
				kbd,
				pre,
				samp {
					font-family: Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
						monospace;
				}
				audio,
				canvas,
				embed,
				iframe,
				img,
				object,
				svg,
				video {
					display: block;
					vertical-align: middle;
				}
				img,
				video {
					max-width: 100%;
					height: auto;
				}
			`}
	/>
)
export default GlobalStyles
